/* @flow */

import WorkbenchIcons from '../components/WorkbenchIcon/WorkbenchIcons';
import FieldKeysGeneric from '../constants/FieldKeysGeneric';
import { TemplateMarketPropertyKeys } from '../templates/TemplateMarketProperties';

export type $DealerHighlightedActivityType = {
  code: string,
  icon: any,
  marketPropertyKey: string,
  fieldKey: string,
  modifierClass: string
};

const DealerHighlightedActivityTypes: Array<$DealerHighlightedActivityType> = [
  {
    code: 'AMG',
    icon: WorkbenchIcons.ICO_AMG,
    marketPropertyKey: TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_AMG,
    fieldKey: FieldKeysGeneric.HIGHLIGHTED_ICON_AMG,
    modifierClass: 'dl-dealer-highlighted-activities__amg'
  },
  {
    code: 'EQC',
    icon: WorkbenchIcons.ICO_EQ,
    marketPropertyKey: TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_EQ,
    fieldKey: FieldKeysGeneric.HIGHLIGHTED_ICON_ECQ,
    modifierClass: 'dl-dealer-highlighted-activities__eqc'
  },
  {
    code: 'EQC_CHARGER',
    icon: WorkbenchIcons.ICO_EQ_CHARGER,
    marketPropertyKey: TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_EQ_CHARGER,
    fieldKey: FieldKeysGeneric.HIGHLIGHTED_ICON_ECQ_CHARGER,
    modifierClass: 'dl-dealer-highlighted-activities__mb-certified'
  },
  {
    code: 'PARTS_PRO',
    icon: WorkbenchIcons.ICO_PARTS_PRO,
    marketPropertyKey: TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_PARTS_PRO,
    fieldKey: FieldKeysGeneric.HIGHLIGHTED_ICON_PARTS_PRO,
    modifierClass: 'dl-dealer-highlighted-activities__parts-pro'
  },
  {
    code: 'WEB_PARTS',
    icon: WorkbenchIcons.ICO_WEBPARTS,
    marketPropertyKey: TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_WEBPARTS,
    fieldKey: FieldKeysGeneric.HIGHLIGHTED_ICON_WEBPARTS,
    modifierClass: 'dl-dealer-highlighted-activities__web-parts'
  },
  {
    code: 'JUNGE_STERNE',
    icon: WorkbenchIcons.ICO_JUNGE_STERNE,
    marketPropertyKey: TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_JUNGE_STERNE,
    fieldKey: FieldKeysGeneric.HIGHLIGHTED_ICON_JUNGE_STERNE,
    modifierClass: 'dl-dealer-highlighted-activities__junge-sterne'
  },
  {
    code: 'MB_CERTIFIED',
    icon: WorkbenchIcons.ICO_MB_CERTIFIED,
    marketPropertyKey: TemplateMarketPropertyKeys.GEN_HIGHLIGHTED_ACTIVITY_MAPPING_MB_CERTIFIED,
    fieldKey: FieldKeysGeneric.HIGHLIGHTED_ICON_MB_CERTIFIED,
    modifierClass: 'dl-dealer-highlighted-activities__mb-certified'
  }
];

export default DealerHighlightedActivityTypes;
